<template>
  <div class="servives-sidebar bg-white">
    <router-link
      to="/service-details-1"
      class="cat-item d-flex justify-content-between align-items-center"
    >
      <span>Influencer Marketing & Celebrity Promotions</span>
      <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore"  
      src="../../assets/images/icon-right-red.png" alt="icon-right-red" />
    </router-link>
    <router-link
      to="/service-details-2"
      class="cat-item d-flex justify-content-between align-items-center"
    >
      <span>Ad Shoots & TV Commercials</span>
      <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore"  
      src="../../assets/images/icon-right-red.png" alt="icon-right-red" />
    </router-link>
    <router-link
      to="/service-details-3"
      class="cat-item d-flex justify-content-between align-items-center"
    >
      <span>Digital Marketing Services</span>
      <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore"  
      src="../../assets/images/icon-right-red.png" alt="icon-right-red" />
    </router-link>
    <router-link
      to="/service-details-4"
      class="cat-item d-flex justify-content-between align-items-center"
    >
      <span>Events & Inaugurations</span>
      <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore"  
       src="../../assets/images/icon-right-red.png" alt="icon-right-red" />
    </router-link>
    <router-link
      to="/service-details-5"
      class="cat-item d-flex justify-content-between align-items-center"
    >
      <span>Verified Badge Services</span>
      <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
      src="../../assets/images/icon-right-red.png" alt="icon-right-red" />
    </router-link>
    <router-link
      to="/service-details-6"
      class="cat-item d-flex justify-content-between align-items-center"
    >
      <span>PR Article & Media Coverage</span>
      <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
      src="../../assets/images/icon-right-red.png" alt="icon-right-red" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: "ServivesSidebar",
};
</script>

<style lang="scss" scoped>
.servives-sidebar {
  padding: 40px;
  border-radius: 20px;
  margin-left: 104px;
  

  .cat-item {
    font-size: 16px;
    font-weight: 600;
    font-family: var(--headingFontFamily);
    color: var(--headingColor);
    margin-bottom: 20px;
     text-decoration: none;
    
    &:last-child {
      margin-bottom: 0;
    }
    &:hover {
      color: var(--mainColor);
    }
  }
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .servives-sidebar {
    margin-left: 0;
    padding: 20px;
    box-shadow: var(--boxShadow);
    .cat-item {
      margin-bottom: 15px;
    }
  }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .servives-sidebar {
    margin-left: 0;
    padding: 30px;
    box-shadow: var(--boxShadow);
    .cat-item {
      margin-bottom: 15px;
    }
  }
}

/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .servives-sidebar {
    margin-left: 0;
    padding: 30px;
  }
}
</style>